export * from './post-ort-kategorie-request.interface';
export * from './post-ort-kategorie-response.interface';
export * from './post-ort-kategorie.shapes';
